import * as React from 'react';
import Collapse from '@material-ui/core/Collapse';

const CustomCollapse = (props) => {
    return <Collapse {...props} />;
};

export { CustomCollapse as Collapse };
